<template>
  <div class="user-index-main" :class="{'bg': personInfo.is_membership && lifeMember}" v-show="loadingOver">
    <div class="user" :class="{'login': _t && !isReviewOfIos, 'isLifeMember': (personInfo.is_membership && lifeMember) || isWxMini || isReviewOfIos || isBaidu}">
      <!-- <i v-if="_t" class="setting iconfont iconsettings" @click="routeTo('/account/users/setting')"></i> -->
      <span class="iconfont iconsaoma" @click="wechatQrcode" v-if="(isWxMini || isWechatBrowser) && _t"></span>
      <img v-if="_t" class="setting-img" src="https://files.wondercv.com/myPage-m/%E8%AE%BE%E7%BD%AE.png" alt="" @click="routeTo('/account/users/setting')">
      <!-- <img src="https://files.wondercv.com/mvue/user-w.png" alt="" class="user-bg"> -->
      <div v-if="_t" class="user-main"
           @click="routeTo(isIos ? '/account/users/basic_info' : '/account/users/vue_basic_info')">
        <div class="user-left">
          <div class="user-profile" :style="{backgroundImage: `url(${personInfo.avatar_url || 'https://files.wondercv.com/default_avatar.png'})`}">
            <!-- <img class="user-gender" v-if="personInfo.gender === '女'" src="https://files.wondercv.com/myPage-m/Group%2010%20Copy%402x.png" alt=""> -->
            <!-- <img class="user-gender" v-if="personInfo.gender === '男'" src="https://files.wondercv.com/myPage-m/Group%2010%20Copy%402xm.png" alt=""> -->
          </div>
          <div class="user-info">
            <p class="user-name">{{ personInfo.username || personInfo.name }}</p>
            <!-- <div class="user-date" v-if="!personInfo.is_membership && !isReviewOfIos">免费版
              <button @click.stop="biuldOrder" v-if="!isWxMini && !isReviewOfIos && !isToutiao && !isBaidu">立即升级
              </button>
            </div>
            <p class="user-date" v-if="personInfo.is_membership && !isReviewOfIos">
              <span v-if="lifeMember">有效期：终身有效</span>
              <span v-else>有效期：{{ personInfo.membership_expired_at | timeFilter('YYYY-MM-DD') }}</span>
              <button @click.stop="biuldOrder" v-if="!isWxMini && !isReviewOfIos && !isToutiao && !isBaidu && !lifeMember">续费</button>
            </p> -->

            <p class="user-date">{{community_identify}}</p>

          </div>
        </div>
        <i class="user-right iconfont iconchevron-right"></i>
      </div>
      <div v-else class="user-main" @click="toLogin">
        <div class="user-left">
          <div class="user-profile"
               :style="{backgroundImage: `url(${personInfo.user_avatar_url || 'https://files.wondercv.com/default_avatar.png'})`}">
            <!-- <img src="https://files.wondercv.com/default_forum_icon.png" alt=""> -->
          </div>
          <div class="user-info">
            <p class="user-name">未登录</p>
            <!-- <p class="user-date">
              超级会员
              <button @click.stop="biuldOrder" v-if="!isWxMini && !isReviewOfIos && !isToutiao && !isBaidu">立即升级</button>
            </p> -->
          </div>
        </div>
        <i class="user-right iconfont iconchevron-right"></i>
      </div>

      <!-- 会员信息 -->
      <div v-if="_t && !isReviewOfIos" class="membership-info" :class="{'isLifeMember': (personInfo.is_membership && lifeMember) || isWxMini || isReviewOfIos || isBaidu}">

        <div class="membership-info-desc">
          <img class="vip-image" src="https://files.wondercv.com/myPage-m/%E7%BC%96%E7%BB%84%2012%402x.png" alt="">

          <p class="vip-desc" v-if="!personInfo.is_membership && !personInfo.membership_expired_at">升级VIP立享专属特权</p>
          <p class="vip-desc" v-if="personInfo.is_membership && lifeMember && lifeMemberPlus">你已是超级简历终身Plus会员</p>
          <p class="vip-desc" v-if="personInfo.is_membership && lifeMember && !lifeMemberPlus">你已是超级简历终身会员</p>
          <p class="vip-desc" v-if="personInfo.is_membership && !lifeMember">会员有效期：{{ personInfo.membership_expired_at | timeFilter('YYYY-MM-DD') }}</p>
          <p class="vip-desc" v-if="!personInfo.is_membership && personInfo.membership_expired_at">当前会员已过期</p>

        </div>

        <template v-if="!isWxMini && !isReviewOfIos && !isToutiao && !isBaidu">
          <div class="membership-info-button" @click.stop="biuldOrder" v-if="!personInfo.is_membership && !personInfo.membership_expired_at"><p>立即升级</p></div>
          <div class="membership-info-button" @click.stop="biuldOrder" v-if="personInfo.is_membership && !lifeMember"><p>立即续费</p></div>
          <div class="membership-info-button" @click.stop="biuldOrder" v-if="!personInfo.is_membership && personInfo.membership_expired_at"><p>立即续费</p></div>
        </template>

      </div>

    </div>
    <goodLocation></goodLocation>

    <template v-if="!(personInfo.is_membership && lifeMember)">
      <div class="line"></div>
      <div class="order" v-if="!isReviewOfIos && !isWxMini && !isBaidu">
        <!-- <div class="order-title">
          <div class="order-name b">
            <img src="https://files.wondercv.com/mvue/huyuan.png" alt="">
            超级会员
          </div>
          <div class="order-me" @click="judgeEnv('/account/orders')">
            我的订单
            <i class="iconfont iconchevron-right"></i>
          </div>
        </div> -->
        <div class="order-option">
          <div class="order-menu" @click="judgeEnv('/account/users/current')">
            <div class="order-msg">
              <p>优惠活动</p>
              <p>邀好友得会员</p>
            </div>
            <img src="https://files.wondercv.com/myPage-m/%E7%BC%96%E7%BB%84%209%403x.png" alt="">
          </div>
          <div class="order-menu bg" @click="judgeEnv('/buy/member/order')">
            <div class="order-msg">
              <p>超级会员</p>
              <p>求职更加高效</p>
            </div>
            <img src="https://files.wondercv.com/myPage-m/%E7%BC%96%E7%BB%84%2010%403x.png" alt="">
          </div>
        </div>
      </div>
    </template>

    <div v-if="personInfo.is_membership && lifeMember" class="placeholder"></div>

<!--    <div v-if="isWxMini" class="item" @click="judgeEnv('/account/users/current')">-->
<!--      <div class="item-name">-->
<!--        <img src="https://files.wondercv.com/me-pc-icon.png" alt="">-->
<!--        优惠活动-->
<!--      </div>-->
<!--      <i class="item-icon iconfont iconchevron-right"></i>-->
<!--    </div>-->

    <!-- <div class="line"></div> -->

<!--    <div class="item" @click="wechatQrcode" v-if="isWxMini || isWechatBrowser">-->
<!--&lt;!&ndash;    <div class="item" @click="wechatQrcode">&ndash;&gt;-->
<!--      <div class="item-name">-->
<!--        <img src="https://files.wondercv.com/m/qrcode_show.png" alt="">-->
<!--        &lt;!&ndash;        <i class="set-icon iconfont iconshequtubiaoweijihuo"></i>&ndash;&gt;-->
<!--        扫码登录-->
<!--      </div>-->
<!--      <i class="item-icon iconfont iconchevron-right"></i>-->
<!--    </div>-->

    <!-- <div class="item" @click="toDiscuss" v-if="!isReviewOfIos">
      <div class="item-name">
        <img src="https://files.wondercv.com/myPage-m/%E8%AE%A8%E8%AE%BA%402x.png" alt="">
        我的讨论
      </div>
      <i class="item-icon iconfont iconchevron-right"></i>
    </div> -->
    <div class="item" @click="toInterView" >
      <div class="item-name" >
        <img src="https://files.wondercv.com/mobile/my/my-test-question.png" alt="" style="width:0.44rem;height:0.54rem;margin-left:0.08rem;margin-right:0.38rem;">
        我的面试题
      </div>
      <i class="item-icon iconfont iconchevron-right"></i>
    </div>
    <div class="item" @click="judgeEnv('/account/orders')" v-if="!isReviewOfIos && !isWxMini && !isBaidu">
      <div class="item-name">
        <img src="https://files.wondercv.com/myPage-m/%E6%88%91%E7%9A%84%E8%AE%A2%E5%8D%95%402x.png" alt="">
        我的订单
      </div>
      <i class="item-icon iconfont iconchevron-right"></i>
    </div>

    <div class="item" @click="toTalent()" v-if="!isAlipayClient && !isUCClient && !isQuaReClient && !isHarmony">
      <div class="item-name">
        <img src="https://files.wondercv.com/myPage-m/%E6%88%91%E8%A6%81%E6%8B%9B%E4%BA%BA.png" alt="">
        我要招人
      </div>
      <i class="item-icon iconfont iconchevron-right"></i>
    </div>

    <div class="line"></div>

    <div class="item" @click="judgeEnv('/welcome/use_pc_page')" v-if="!isReviewOfIos && !isAlipayClient && !isUCClient && !isQuaReClient">
      <div class="item-name">
        <img src="https://files.wondercv.com/myPage-m/%E7%94%B5%E8%84%91%E7%AB%AF%E5%88%B6%E4%BD%9C%E7%AE%80%E5%8E%86.png" alt="">
        电脑端制作简历
      </div>
      <i class="item-icon iconfont iconchevron-right"></i>
    </div>

    <div class="item" @click="service" v-if="!isWxMini && !isBaidu && !isQQMini && !isAlipayClient && !isReviewOfIos && !isUCClient && !isQuaReClient">
      <div class="item-name">
        <img src="https://files.wondercv.com/myPage-m/%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D.png" alt="">
        在线客服
      </div>
      <i class="item-icon iconfont iconchevron-right"></i>
    </div>

    <div class="item" v-if="!isWxMini" @click="judgeEnv('/feedbacks/new')">
      <div class="item-name">
        <img src="https://files.wondercv.com/myPage-m/%E9%97%AE%E9%A2%98%E5%8F%8D%E9%A6%88.png" alt="">
        问题反馈
      </div>
      <i class="item-icon iconfont iconchevron-right"></i>
    </div>

    <div class="line"
         v-if="!isReviewOfIos || !isWxMini || (!isWxMini && !isBaidu && !isQQMini && !isAlipayClient && !isReviewOfIos)"></div>

    <div class="item" v-if="isIos" @click="iosShare">
      <div class="item-name">
        <img src="https://files.wondercv.com/me-share-icon.png" alt="">
        分享APP
      </div>
      <i class="item-icon iconfont iconchevron-right"></i>
    </div>

    <div class="line" v-if="isIos"></div>

    <w-tabbar v-show="iosOrAndroidShow" :page="'me'"/>
  </div>
</template>
<script>
	import { envMixin } from '../../assets/js/mixin/global'
	import { componentsMixin } from '../../assets/js/mixin/components'
	import { toLogin } from '../../assets/js/utils'
	import WTabbar from '../../components/global/w-tabbar'
	import Cookies from 'js-cookie'
	import { mapActions, mapState } from 'vuex'
	import { userMixin } from '../../assets/js/mixin/user'
  import goodLocation from '@/views/account/components/goodLocation'
  // import wx from 'weixin-js-sdk'

  const moment = require('moment')

	export default {
		name: 'UserIndex',
		mixins: [ envMixin, componentsMixin, userMixin ],
		components: {
			WTabbar,
      goodLocation
		},
		data () {
			return {
				_t: '',
				personInfo: {},
				loadingOver: false,
        username: '',
        community_identify: '' // 用户社群身份信息
			}
		},
		computed: {
      // 判断是否是终身会员
			lifeMember () {
				let time = moment(this.personInfo.membership_expired_at).format('YYYYMMDD')
        return time > '21000101'
      },
      // 判断是否是终身会员Plus
      lifeMemberPlus (){
        let m1 = moment()
        let { membership_expired_at } = this.personInfo
        let m2 = moment(membership_expired_at)
		    let day = m2.diff(m1,'day')
        return day >= 33000
      },
    },
		async created () {
			let _t = Cookies.get('_t') || Cookies.get('_t_plugin')
			this._t = _t
			setTimeout(() => {
				this.loadingOver = true
			}, 501)
      if (_t) {
        await this.getUserData()
        this.personInfo = this.userData

        this.getCommunityInfo()
      }
      

			// 获取用户信息
			// let res = await this.$api.online.getCvBasicInfo(this.cvAccountToken)
			// this.username = res.data && res.data.username
      //
			// // 获取用户信息
			// res = await this.$api.user.AccountUsersMobileAccountIndex()
			// if (res.status === 1) {
			// 	this.personInfo = res.data || {}
      // }
    },
    methods: {
			...mapActions('user', [ 'getUserAccountInfo' ]),
			toLogin () {
			  if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/login/login`
          })
        }else {
          toLogin()
        }
      },
      toTalent () {
        window.location.href = `https://www.wondercv.${ process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com' }/talent/tips`
      },
      // 调取微信扫码
      wechatQrcode() {
			  if (this._t) {
          this.$wechat.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
            success: (res) => {
              let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
              let uuid;
              if (result) {
                if (result.includes('http')) {
                  uuid = result.split("/").pop()
                } else {
                  uuid = result
                }
                if (uuid.length === 22) {
                  this.$router.push({ path: '/scan_login', query: { uuid: uuid }})
                } else {
                  this.showToast('请扫描正确的二维码', 1500)
                }
              }
            }
          });
        }else {
			    this.showToast('请先登录',1500)
        }
      },
      // 微信扫码成功之后调取登录接口
      async qrCodeToLogin(data) {
			  try {
          let res = await this.$api.auth.scanQRCodeToLogin(data)
          if (res.code === 1000) {
            if (res.data && res.data.timeout === 2) {
              this.showToast('二维码失效，请刷新页面重试',1500)
            } else if (res.data && res.data.status === 1) {
              this.showToast('扫码成功，请等待跳转',1500)
            }
          }else {
            this.showToast('扫码失败，请重试',1500)
          }
        } catch (e) {
			    console.error(e,"扫码登录出错")
        }
      },
      // 获取 社群身份信息
      async getCommunityInfo () {
        let res = await this.$api.community.getCommunityInfo(this.cvAccountToken)
        if (res.data.status === 'student') {
          if (!res.data.stu_community_prefix || !res.data.stu_community_suffix) {
            this.community_identify = '点击设置社群身份'
            return false
          }
          this.community_identify = res.data.stu_community_prefix + '/' + res.data.stu_community_suffix
        } else if (res.data.status === 'already_work') {
          if (!res.data.com_community_prefix || !res.data.com_community_suffix) {
            this.community_identify = '点击设置社群身份'
            return false
          }
          this.community_identify = res.data.com_community_prefix + '/' + res.data.com_community_suffix
        } else {
          this.community_identify = '点击设置社群身份'
        }
      },
			biuldOrder () {
				if (!this._t) {
					toLogin(process.env.VUE_APP_HOST + '/account/users/index')
					return false
				}
				if (this.isWxMini) {
          // this.$wechat.miniProgram.navigateTo({ url: '/pages/customService/customService' })
          // this.$wechat.miniProgram.navigateTo({ url: `/pages/memberPay/memberPay` })
          if (this.mobileOS === 'iOS') {
            this.$wechat.miniProgram.navigateTo({
              // url: `/pages/customService/customService`
              url: `/pages/memberPay/memberPay`
            })
          } else {
            this.$router.push('/buy/member/order')
          }
				} else if (this.isIos) {
					this.dialogShow = true
				} else {
					// 提交订单, 跳转页面 POST
					// this.$api.user.createImprovedOrder({ from_vue: 'true', improved_order: { package: 'membership' } })
					// 	.then((response) => {
					// 		if (response.code === 1000) {
					// 			window.location.href = process.env.VUE_APP_LINK + `/orders/${ response.data.order_token }`
					// 		}
					// 	})
					// 	.catch(() => {
					// 		this.showToast('请求失败，请重试')
					// 	})
          this.$router.push({
            name:'buyMemberOrder',
            params: {
              from: 'myPage'
            }
          })
				}
			},

			judgeEnv (url) {
				if (this.$isWxMiniini) {
          // this.$wechat.miniProgram.navigateTo({ url: '/pages/customService/customService' })
          // this.$wechat.miniProgram.navigateTo({ url: `/pages/memberPay/memberPay` })
          if (this.mobileOS === 'iOS') {
            this.$wechat.miniProgram.navigateTo({
              // url: `/pages/customService/customService`
              url: `/pages/memberPay/memberPay`
            })
          } else {
            this.$router.push('/buy/member/order')
          }
				} else {
					let constRouter = [ '/account/orders', '/account/users/current' ]
					if (!this._t && constRouter.indexOf(url) !== -1) {
						toLogin(process.env.VUE_APP_HOST + url)
						return false
					}
					this.routeTo(url)
				}
			},
			// ios分享app
			iosShare () {
				if (this.isIos) {
					this.handlerBridge('shareApp', {
						title: '超级简历 WonderCV - 智能专业简历制作',
						desc: 'HR 推荐的专业简历，手机电脑同步编辑，中英双语模板，名企精英都在用',
						url: 'https://datayi.cn/w/woVLaZWR'
					})
				}
			},
			// 客服
			async service () {
				let res = await this.$api.user.getUdeskOnlineUrl()
				if (res.code !== 1000) {
					this.showToast('网络出错')
					return false
				}
				window.location.href = res.data.udesk_online_url
			},
      // 跳转到讨论页
      toDiscuss(){
			  this.$router.push({path:'/account/discuss'});
      },

      //跳转答题页面
      toInterView(){
        this.$router.push({path:'/interview/index'});
      }
		},
	}
</script>
<style lang="scss" scoped>
@import "../../assets/scss/global/mixin";
.set-icon{
  font-size: 22px;
  margin-right: 4px;
  color: rgb(114,115,125);
}
  .user-index-main {
    margin-bottom: 45px;
    &.bg {
      background: #505667;
    }
    .user {
      width: 100%;
      height: 158px;
      background: #505667;
      // background: linear-gradient(121deg, rgba(89, 91, 110, 1) 0%, rgba(74, 76, 91, 1) 100%);
      position: relative;
      overflow: hidden;
      z-index: 1;
      &.login {
        height: 198px;
      }
      &.isLifeMember {
        height: 172px;
      }
      .setting {
        font-size: 20px;
        font-weight: 700;
        color: #fff;
        position: absolute;
        top: 16px;
        right: 24px;
      }

      .setting-img {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 16px;
        right: 24px;
      }
      .iconsaoma {
        font-size: 20px;
        position: absolute;
        top: 16px;
        right: 60px;
        color: #eee;
      }
      .user-main {
        margin-top: 52px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        z-index: 2;
        .user-left {
          display: flex;
          align-items: center;
          margin-left: 24px;
          .user-profile {
            position: relative;
            width: 62px;
            height: 62px;
            border-radius: 31px;
            margin-right: 16px;
            // overflow: hidden;
            background-size: cover;
            background-position: 50%;
            // img {
            //   min-width: 100%;
            //   min-height: 100%;
            // }

            .user-gender {
              position: absolute;
              top: 1px;
              right: 1px;
              width: 18px;
              height: 18px;
            }
          }
          .user-info {
            flex: 1;
            .user-name {
              font-size: 20px;
              color: #fff;
              font-weight: 500;
              @include ellipsis(255px);
            }
            // .user-date {
            //   margin-top: 10px;
            //   font-size: 14px;
            //   color: #fff;
            //   display: flex;
            //   align-items: center;
            //   button {
            //     border: none;
            //     // width: 42px;
            //     padding: 0 6px;
            //     height: 18px;
            //     line-height: 18px;
            //     border-radius: 9px;
            //     background: linear-gradient(180deg, rgba(253, 213, 133, 1) 0%, rgba(231, 191, 111, 1) 100%);
            //     font-size: 12px;
            //     color: #fff;
            //     margin-left: 10px;
            //   }
            // }
            .user-date {
              margin-top: 8px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.8);
              line-height: 18px;
              @include ellipsis(255px);
            }
          }
        }
        .user-right {
          font-size: 20px;
          color: #fff;
          font-weight: 600;
          margin-right: 24px;
        }
      }
      .user-bg {
        width: 106px;
        height: 69px;
        position: absolute;
        top: 52px;
        right: 0;
        z-index: 0;
      }
      .membership-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        left: 50%;
        bottom: 19px;
        transform: translateX(-50%);
        width: 343px;
        height: 44px;
        padding: 0 15px;
        background: #414653;
        border-radius: 8px 8px 0px 0px;

        &.isLifeMember {
          bottom: 0;
        }

        .membership-info-desc {
          display: flex;
          align-items: center;
          height: 100%;
          .vip-image {
            width: 34px;
            height: 14px;
            margin-right: 8px;
            // vertical-align: top;
          }

          .vip-desc {
            font-size: 13px;
            font-weight: 500;
            color: #F6D591;
            line-height: 13px;
            // margin-bottom: -2px;
          }
        }

        .membership-info-button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 64px;
          height: 20px;
          background: linear-gradient(270deg, #F5D490 0%, #FFE7AD 100%);
          border-radius: 11px;

          >p{
            height: 12px;
            font-size: 12px;
            font-weight: 400;
            color: #414653;
            text-align: center;
          }
        }
      }

    }
    .line {
      width: 100%;
      background: #F9F9F9;
      height: 6px;
      border-top: 2px solid #fff;
      border-bottom: 2px solid #fff;
      box-sizing: content-box;
    }
    .order {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      // height: 109px;
      background: #fff;
      border-radius: 8px 8px 0 0;
      margin-top: -24px;
      position: relative;
      z-index: 2;
      padding: 0 15px;
      padding-top: 24px;
      padding-bottom: 13px;
      .order-title {
        padding: 24px 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .order-name {
          display: flex;
          align-items: center;
          img {
            width: 15px;
            margin-right: 10px;
          }
        }
        .b {
          font-weight: 700;
        }
        .order-me {
          font-size: 14px;
          color: #9C9C9C;
          .iconfont {
            color: #9C9C9C;
            font-size: 14px;
            margin-left: 4px;
          }
        }
      }
      .order-option {
        width: 343px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .order-menu {
          width: 162px;
          height: 66px;
          background: rgba(255, 113, 71, 0.05);
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-right: 18px;
          &.bg {
            margin-right: 0;
            background: rgba(255, 174, 39, 0.07);
            .order-msg {
              p:first-child {
                color: #FEA109;
              }
              p:last-child {
                color: #FEA109;
              }
            }
          }
          img {
            display: block;
            width: 42px;
            margin-right: 14px;
          }
          .order-msg {
            margin-left: 16px;
            margin-top: 3px;
            p:first-child {
              font-size: 14px;
              color: #FF7047;
              font-weight: 500;;
            }
            p:last-child {
              font-size: 12px;
              color: #FF7047;
              margin-top: 6px;
            }
          }
        }
      }
    }
    .item {
      width: 100%;
      height: 47px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      .item-name {
        font-size: 16px;
        color: #404040;
        display: flex;
        align-items: center;
        .iconfont {
          margin-right: 10px;
          font-weight: 600;
        }
        img {
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
      }
      .item-icon {
        font-size: 18px;
        color: #CBCBCB;
      }
    }
  }

  .placeholder {
    height:10px;
    background: #fff;
    border-radius: 8px 8px 0 0;
  }
</style>
